'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function EditableButtons(props) {
  var closeTxt = props.closeTxt,
      disabled = props.disabled,
      onClose = props.onClose,
      onSubmit = props.onSubmit,
      showClose = props.showClose,
      submitTxt = props.submitTxt;
  return _react2.default.createElement('div', {
    className: 'editable-buttons'
  }, _react2.default.createElement('button', {
    className: 'editable-submit',
    disabled: disabled,
    type: 'submit',
    title: submitTxt,
    onClick: onSubmit
  }, _react2.default.createElement('span', {
    className: 'hidden'
  }, submitTxt), _react2.default.createElement(_Icon2.default, {
    symbol: 'check'
  })), showClose && _react2.default.createElement('button', {
    className: 'editable-close',
    type: 'button',
    title: closeTxt,
    onClick: onClose
  }, _react2.default.createElement('span', {
    className: 'hidden'
  }, closeTxt), _react2.default.createElement(_Icon2.default, {
    symbol: 'ban'
  })));
} // import css from '../cape-style'


EditableButtons.propTypes = {
  closeTxt: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  showClose: _propTypes2.default.bool,
  submitTxt: _propTypes2.default.string.isRequired
};
EditableButtons.defaultProps = {
  closeTxt: 'Cancel',
  showClose: true,
  submitTxt: 'Submit'
};
exports.default = EditableButtons;
module.exports = exports['default'];